const mountArtistStrip = () => {
  const header = document.querySelector('#header-component');
  if (!header) return;

  const primaryLinks = [...header.querySelectorAll('.header__row--bottom .menu-list__link')];
  const artistsMenuLink = primaryLinks.find((link) => link.textContent.trim().toLowerCase() === 'artists');
  const artistLinks = [...header.querySelectorAll('.mega-menu__link')];

  if (window.location.pathname === '/') {
    primaryLinks.forEach((link) => link.classList.remove('menu-list__link--active'));
    primaryLinks[0]?.classList.add('menu-list__link--active');
  }

  let strip = header.querySelector('.gooka-artist-strip');
  if (!strip && artistLinks.length) {
    strip = document.createElement('nav');
    strip.id = 'gooka-artist-strip';
    strip.className = 'gooka-artist-strip';
    strip.setAttribute('aria-label', 'Artists');
    strip.setAttribute('aria-hidden', 'true');

    artistLinks.forEach((source) => {
      const link = document.createElement('a');
      link.className = 'gooka-artist-strip__link';
      link.href = source.href;
      link.textContent = source.textContent.trim();
      if (new URL(source.href).pathname === window.location.pathname) {
        link.setAttribute('aria-current', 'page');
      }
      strip.appendChild(link);
    });

    header.appendChild(strip);
  }

  const artistsMenuItem = artistsMenuLink?.closest('.menu-list__list-item');
  artistsMenuItem?.querySelector('.menu-list__submenu')?.remove();
  artistsMenuLink?.setAttribute('aria-controls', 'gooka-artist-strip');
  artistsMenuLink?.setAttribute('aria-expanded', String(strip?.classList.contains('gooka-artist-strip--open')));
  artistsMenuLink?.removeAttribute('aria-haspopup');

  if (!document.documentElement.dataset.gookaArtistToggleReady) {
    document.documentElement.dataset.gookaArtistToggleReady = 'true';
    document.addEventListener('click', (event) => {
      const menuLink = event.target instanceof Element
        ? event.target.closest('.header__row--bottom .menu-list__link')
        : null;
      if (!menuLink || menuLink.textContent.trim().toLowerCase() !== 'artists') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const currentStrip = document.querySelector('#header-component .gooka-artist-strip');
      if (!currentStrip) return;

      const isOpen = currentStrip.classList.toggle('gooka-artist-strip--open');
      currentStrip.setAttribute('aria-hidden', String(!isOpen));
      menuLink.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) currentStrip.scrollTo({ left: 0, behavior: 'smooth' });
    }, true);
  }
};

mountArtistStrip();

const mountCatalogToolbarCount = () => {
  document.querySelectorAll(':is(main[data-template^="collection"], main[data-template="search"]) .facets-toggle').forEach((toolbar) => {
    const wrapper = toolbar.closest('.collection-wrapper');
    const source = wrapper?.querySelector('.facets-block-wrapper--horizontal .products-count-wrapper [title="Product count"]');
    const resultsButton = wrapper?.querySelector('#filters-drawer .facets__see-results');
    let count = toolbar.querySelector('.gooka-toolbar-count');
    if (!count) {
      count = document.createElement('span');
      count.className = 'gooka-toolbar-count';
      toolbar.appendChild(count);
    }

    const availability = new URL(window.location.href).searchParams.getAll('filter.v.availability');
    const soldOutOnly = availability.includes('0') && !availability.includes('1');
    if (soldOutOnly) {
      void getAvailabilityCounts().then(({ soldOut }) => {
        if (soldOut === null || !count.isConnected) return;
        const label = `${soldOut} ${soldOut === 1 ? 'item' : 'items'}`;
        if (count.textContent !== label) count.textContent = label;
      });
      return;
    }

    const label = source?.textContent.trim() || resultsButton?.textContent.trim().replace(/^see\s+/i, '') || '';
    if (label && count.textContent !== label) count.textContent = label;
  });
};

const mountProductCardActions = () => {
  clearPersistedProductCardFocus();
  disableProductCardTransitions();
  restoreCatalogReturnPosition();

  document.querySelectorAll(':is(main[data-template^="collection"], main[data-template="search"]) .product-grid__card').forEach((card) => {
    const action = card.querySelector('.quick-add');
    const details = card.querySelector('.group-block-content');
    const badges = [...card.querySelectorAll('.product-badges__badge')];
    const badgeLabels = badges.map((badge) => badge.textContent.trim().toLowerCase());
    const actionButtons = [...card.querySelectorAll('.quick-add__button')];
    const variantQuickAdd = card.querySelector('.quick-add__button--choose');
    const isSoldOut = badgeLabels.includes('sold out') ||
      (actionButtons.length > 0 && actionButtons.every((button) => button.disabled));

    if (action && variantQuickAdd && !card.dataset.gookaQuickAddPrefetchReady) {
      card.dataset.gookaQuickAddPrefetchReady = 'true';

      const prefetchQuickAdd = () => {
        if (!window.matchMedia('(min-width: 750px)').matches || card.dataset.gookaQuickAddPrefetched) return;

        const productUrl = action.productPageUrl;
        if (!productUrl) return;

        card.dataset.gookaQuickAddPrefetched = 'true';
        void fetch(productUrl, {
          credentials: 'same-origin',
          cache: 'force-cache',
        })
          .then((response) => {
            if (!response.ok) throw new Error('Unable to prefetch quick add');
            return response.text();
          })
          .catch(() => {
            delete card.dataset.gookaQuickAddPrefetched;
          });
      };

      card.addEventListener('pointerenter', prefetchQuickAdd, { once: true, passive: true });
      action.addEventListener('focusin', prefetchQuickAdd, { once: true });
    }

    card
      .querySelectorAll(
        '.card-gallery .slideshow-control--previous, .card-gallery .slideshow-control--next'
      )
      .forEach((control) => {
        if (control.dataset.gookaGalleryControlReady) return;
        control.dataset.gookaGalleryControlReady = 'true';

        control.addEventListener('click', (event) => {
          event.stopPropagation();
          if (event.defaultPrevented) return;

          const slideshow = control.closest('slideshow-component');
          const actionName = control.classList.contains('slideshow-control--next') ? 'next' : 'previous';
          const actionHandler = slideshow?.[actionName];
          if (typeof actionHandler !== 'function') return;

          event.preventDefault();
          actionHandler.call(slideshow, event);
        });
      });

    badges.forEach((badge) => {
      badge.classList.toggle('gooka-product-badge--sale', badge.textContent.trim().toLowerCase() === 'sale');
    });
    card.classList.toggle('gooka-product-card--sold-out', isSoldOut);
    if (action && details && action.parentElement !== details) details.appendChild(action);
  });
};

const availabilityCountCache = new Map();

const parseCatalogCount = (markup) => {
  const parsed = new DOMParser().parseFromString(markup, 'text/html');
  const countSource = parsed.querySelector(
    '.products-count-wrapper [title="Product count"], .product-count__text, .facets__see-results'
  );
  const countMatch = countSource?.textContent.replaceAll(',', '').match(/\d+/);
  return countMatch ? Number(countMatch[0]) : null;
};

const getAvailabilityCounts = () => {
  const baseUrl = new URL(window.location.href);
  baseUrl.searchParams.delete('page');
  baseUrl.searchParams.delete('sort_by');
  baseUrl.searchParams.delete('filter.v.availability');
  const cacheKey = baseUrl.toString();

  if (!availabilityCountCache.has(cacheKey)) {
    const fetchCount = async (availability = null) => {
      const countUrl = new URL(baseUrl);
      if (availability !== null) countUrl.searchParams.set('filter.v.availability', availability);
      const response = await fetch(countUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Unable to load availability count');
      return parseCatalogCount(await response.text());
    };

    availabilityCountCache.set(
      cacheKey,
      Promise.all([fetchCount(), fetchCount('1')])
        .then(([total, inStock]) => ({
          inStock,
          soldOut: total === null || inStock === null ? null : Math.max(total - inStock, 0),
        }))
        .catch(() => ({ inStock: null, soldOut: null }))
    );
  }

  return availabilityCountCache.get(cacheKey);
};

const mountTrueSoldOutResults = () => {
  const availability = new URL(window.location.href).searchParams.getAll('filter.v.availability');
  const soldOutOnly = availability.includes('0') && !availability.includes('1');

  document.querySelectorAll(':is(main[data-template^="collection"], main[data-template="search"]) .product-grid__item').forEach((item) => {
    const card = item.querySelector('.product-grid__card');
    item.classList.toggle(
      'gooka-hide-available-product',
      soldOutOnly && !card?.classList.contains('gooka-product-card--sold-out')
    );
  });
};

const mountAvailabilityCounts = async (dialog) => {
  const availabilityInputs = [...dialog.querySelectorAll('input[name="filter.v.availability"]')];
  if (!availabilityInputs.length) return;

  availabilityInputs.forEach((input) => {
    const label = dialog.querySelector(`label[for="${input.id}"]`);
    const labelText = label?.querySelector('.checkbox__label-text');
    if (!label || !labelText) return;

    const nextLabel = input.value === '1' ? 'In stock' : 'Sold out';
    if (labelText.textContent.trim() !== nextLabel) labelText.textContent = nextLabel;

    let count = label.querySelector('.gooka-availability-count');
    if (!count) {
      count = document.createElement('span');
      count.className = 'gooka-availability-count';
      count.setAttribute('aria-hidden', 'true');
      label.appendChild(count);
    }
  });

  const counts = await getAvailabilityCounts();
  if (!dialog.isConnected) return;

  availabilityInputs.forEach((input) => {
    const count = dialog.querySelector(`label[for="${input.id}"] .gooka-availability-count`);
    const nextCount = input.value === '1' ? counts.inStock : counts.soldOut;
    if (count && nextCount !== null && count.textContent !== String(nextCount)) {
      count.textContent = String(nextCount);
    }
  });
};

const releaseStaleDialogScrollLock = (ignoredDialog = null) => {
  const hasOpenScrollLock = [...document.querySelectorAll('[open][scroll-lock]')]
    .some((element) => element !== ignoredDialog);

  if (!hasOpenScrollLock) {
    const lockedScrollTop = Number.parseInt(document.body.style.top, 10);

    document.documentElement.removeAttribute('scroll-lock');

    if (document.body.style.position === 'fixed') {
      document.body.style.removeProperty('width');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');

      if (Number.isFinite(lockedScrollTop)) {
        window.scrollTo({ top: lockedScrollTop * -1, behavior: 'instant' });
      }
    }
  }

  const hasOpenFilterSheet = [...document.querySelectorAll('dialog.gooka-catalog-filter-sheet[open]')]
    .some((element) => element !== ignoredDialog);

  if (!hasOpenFilterSheet) {
    document.documentElement.classList.remove('gooka-filter-is-open');
  }
};

const mountCatalogFilterSheet = () => {
  const dialog = document.querySelector('#filters-drawer dialog.facets--drawer');
  if (!dialog) return;

  dialog.classList.add('gooka-catalog-filter-sheet');

  const title = dialog.querySelector('.facets-drawer__title');
  const resetButton = dialog.querySelector('.facets__clear-all');
  const doneButton = dialog.querySelector('.facets__see-results');
  const availabilityPanel = dialog.querySelector('details[id*="filter-v-availability"]');
  const sortPanel = dialog.querySelector('details[id^="Sorting-"]');

  if (title && title.textContent.trim() !== 'Filters') title.textContent = 'Filters';
  if (resetButton && resetButton.textContent.trim() !== 'Reset') resetButton.textContent = 'Reset';
  if (doneButton && doneButton.textContent.trim() !== 'Done') doneButton.textContent = 'Done';

  if (availabilityPanel) {
    const availabilityLabel = availabilityPanel.querySelector('.facets__label');
    const availabilityStatus = availabilityPanel.querySelector('.facets__status');
    if (availabilityLabel && availabilityLabel.textContent.trim() !== 'Availability') {
      availabilityLabel.textContent = 'Availability';
    }
    if (availabilityStatus?.textContent.trim().toLowerCase() === 'out of stock') {
      availabilityStatus.textContent = 'Sold out';
    }
    availabilityPanel.closest('.facets__item')?.setAttribute('data-filter-param-name', 'filter-v-availability');
  }

  if (sortPanel) {
    sortPanel.classList.remove('mobile:hidden');
    const sortLabel = sortPanel.querySelector('.facets__label');
    if (sortLabel && sortLabel.textContent.trim() !== 'Sort by') sortLabel.textContent = 'Sort by';
  }

  if (!dialog.dataset.gookaFilterSheetReady) {
    dialog.dataset.gookaFilterSheetReady = 'true';
    if (availabilityPanel) availabilityPanel.open = true;
    if (sortPanel) {
      sortPanel.open = window.matchMedia('(min-width: 750px)').matches ||
        document.documentElement.classList.contains('gooka-sort-is-refreshing');
      if (document.documentElement.classList.contains('gooka-sort-is-refreshing')) {
        const sortOptions = sortPanel.querySelector('.sorting-filter__options');
        const savedScroll = Number(document.documentElement.dataset.gookaSortScroll || 0);
        window.requestAnimationFrame(() => { if (sortOptions) sortOptions.scrollTop = savedScroll; });
      }
    }

    const revealWithMotion = () => {
      dialog.classList.remove('gooka-is-visible', 'gooka-is-closing');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (dialog.open) dialog.classList.add('gooka-is-visible');
        });
      });
    };

    const closeWithMotion = (sourceButton) => {
      if (!dialog.open || dialog.classList.contains('gooka-is-closing')) return;

      dialog.classList.add('gooka-is-closing');
      releaseStaleDialogScrollLock(dialog);
      window.requestAnimationFrame(() => releaseStaleDialogScrollLock(dialog));
      window.setTimeout(() => {
        dialog.dataset.gookaAllowClose = 'true';
        dialog.close();
        releaseStaleDialogScrollLock();
        window.setTimeout(() => delete dialog.dataset.gookaAllowClose, 0);
      }, 620);
    };

    dialog.addEventListener('toggle', () => {
      if (!dialog.open) return;

      const filterWasAlreadyOpen = document.documentElement.classList.contains('gooka-filter-is-open');
      document.documentElement.classList.add('gooka-filter-is-open');
      if (filterWasAlreadyOpen) {
        dialog.classList.remove('gooka-is-closing');
        dialog.classList.add('gooka-is-visible');
      } else {
        revealWithMotion();
      }
    });

    dialog.addEventListener('close', () => {
      dialog.classList.remove('gooka-is-visible', 'gooka-is-closing');
      if (!document.querySelector('dialog.gooka-catalog-filter-sheet[open]')) {
        document.documentElement.classList.remove('gooka-filter-is-open');
      }
      window.requestAnimationFrame(releaseStaleDialogScrollLock);
    });

    window.addEventListener(
      'click',
      (event) => {
        if (!dialog.contains(event.target) && event.target !== dialog) return;
        if (dialog.dataset.gookaAllowClose === 'true') return;
        const closeButton = event.target instanceof Element
          ? event.target.closest('.facets__see-results, .facets-drawer__close')
          : null;
        const clickedBackdrop = event.target === dialog;
        if (!closeButton && !clickedBackdrop) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        closeWithMotion(closeButton);
      },
      true
    );

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeWithMotion(dialog.querySelector('.facets-drawer__close'));
    });

    sortPanel?.addEventListener(
      'click',
      (event) => {
        const sortOption = event.target instanceof Element
          ? event.target.closest('.sorting-filter__option')
          : null;
        if (!sortOption || !dialog.open) return;

        const page = document.documentElement;
        const sortOptions = sortPanel.querySelector('.sorting-filter__options');
        page.classList.add('gooka-sort-is-refreshing');
        page.dataset.gookaSortScroll = String(sortOptions?.scrollTop || 0);

        window.setTimeout(() => {
          if (dialog.isConnected && dialog.open) {
            dialog.dataset.gookaAllowClose = 'true';
            dialog.close();
            window.setTimeout(() => delete dialog.dataset.gookaAllowClose, 0);
          }

          releaseStaleDialogScrollLock();
        }, 0);

        window.setTimeout(() => {
          page.classList.remove('gooka-sort-is-refreshing');
          delete page.dataset.gookaSortScroll;
          releaseStaleDialogScrollLock();
        }, 1600);
      },
      true
    );

    if (dialog.open) {
      if (document.documentElement.classList.contains('gooka-filter-is-open')) {
        dialog.classList.add('gooka-is-visible');
      } else {
        document.documentElement.classList.add('gooka-filter-is-open');
        revealWithMotion();
      }
    }
  }

  void mountAvailabilityCounts(dialog);
};

const mountHomepageFilterSheets = () => {
  document.querySelectorAll('[data-gooka-filter-open]').forEach((button) => {
    if (button.dataset.gookaFilterReady) return;
    button.dataset.gookaFilterReady = 'true';
    button.addEventListener('click', () => {
      const sheet = document.getElementById(button.dataset.gookaFilterOpen);
      if (sheet instanceof HTMLDialogElement && !sheet.open) sheet.showModal();
    });
  });

  document.querySelectorAll('[data-gooka-filter-close]').forEach((button) => {
    if (button.dataset.gookaFilterReady) return;
    button.dataset.gookaFilterReady = 'true';
    button.addEventListener('click', () => button.closest('dialog')?.close());
  });
};

const formatCartMoney = (cents, currency = 'USD') => {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency,
    }).format(cents / 100);
  } catch {
    return `$${(cents / 100).toFixed(2)}`;
  }
};

const mountCartDrawer = () => {
  const drawer = document.querySelector('cart-drawer-component');
  if (!drawer) return;

  drawer.classList.add('gooka-cart-drawer');

  const dialog = drawer.querySelector('.cart-drawer__dialog');
  const isEmpty = dialog?.classList.contains('cart-drawer--empty');
  const header = drawer.querySelector('.cart-drawer__header');

  if (isEmpty) {
    let emptyTitle = header?.querySelector('.gooka-empty-cart-title');
    if (header && !emptyTitle) {
      emptyTitle = document.createElement('span');
      emptyTitle.className = 'cart-drawer__heading h3 gooka-empty-cart-title';
      emptyTitle.textContent = 'Your cart';
      header.prepend(emptyTitle);
    }

    const emptyMessage = drawer.querySelector('.cart-drawer__heading--empty');
    if (emptyMessage && emptyMessage.textContent.trim() !== 'Your cart is empty') {
      emptyMessage.textContent = 'Your cart is empty';
    }

    drawer.querySelectorAll('.cart-items__wrapper > p, .cart-items__empty-button').forEach((element) => {
      element.remove();
    });
    return;
  }

  const heading = drawer.querySelector('.cart-drawer__heading');
  if (heading) {
    const bubble = heading.querySelector('.cart-bubble');
    const currentLabel = [...heading.childNodes]
      .filter((node) => node !== bubble)
      .map((node) => node.textContent)
      .join('')
      .trim();
    if (currentLabel !== 'Your cart') {
      [...heading.childNodes].forEach((node) => {
        if (node !== bubble) node.remove();
      });
      heading.prepend(document.createTextNode('Your cart'));
    }
  }

  const discount = drawer.querySelector('.cart-discount');
  const discountTrigger = discount?.querySelector('.disclosure-trigger');
  const discountLabel = discountTrigger?.querySelector('.disclosure-trigger__label');
  const discountContent = discount?.querySelector('.disclosure-content');
  if (discount) discount.classList.add('gooka-cart-discount');
  if (discountLabel && discountLabel.textContent.trim() !== 'Discount code') {
    discountLabel.textContent = 'Discount code';
  }
  if (discountTrigger) discountTrigger.setAttribute('aria-expanded', 'true');
  if (discountContent) {
    discountContent.removeAttribute('inert');
    discountContent.removeAttribute('hidden');
  }

  const actions = drawer.querySelector('.cart-actions');
  if (actions && !drawer.querySelector('.gooka-gift-card')) {
    const giftCard = document.createElement('div');
    giftCard.className = 'gooka-gift-card';
    giftCard.innerHTML = `
      <label for="gooka-gift-card-code">Gift card</label>
      <div class="gooka-gift-card__form">
        <input id="gooka-gift-card-code" type="text" autocomplete="off" placeholder="Enter gift card code">
        <button type="button">Apply</button>
      </div>
      <p class="gooka-gift-card__note" aria-live="polite"></p>
    `;
    actions.insertAdjacentElement('afterend', giftCard);

    giftCard.querySelector('button')?.addEventListener('click', () => {
      const input = giftCard.querySelector('input');
      const note = giftCard.querySelector('.gooka-gift-card__note');
      if (!input?.value.trim()) {
        if (note) note.textContent = 'Enter a gift card code';
        input?.focus();
        return;
      }
      if (note) note.textContent = 'Gift cards are applied securely at checkout';
    });
  }

  const totalContainer = drawer.querySelector('.cart__total-container');
  if (totalContainer && !drawer.querySelector('.gooka-cart-estimates')) {
    const estimates = document.createElement('div');
    estimates.className = 'gooka-cart-estimates';
    estimates.innerHTML = `
      <div><span>Subtotal</span><span data-gooka-cart-subtotal></span></div>
      <div><span>Est. shipping</span><span data-gooka-cart-shipping></span></div>
      <div><span>Est. tax</span><span>Calculated at checkout</span></div>
    `;
    totalContainer.insertAdjacentElement('beforebegin', estimates);

    const freeShipping = document.createElement('div');
    freeShipping.className = 'gooka-free-shipping';
    freeShipping.innerHTML = `
      <div class="gooka-free-shipping__track" aria-hidden="true"><span></span></div>
      <p data-gooka-free-shipping-message></p>
    `;
    totalContainer.insertAdjacentElement('afterend', freeShipping);
  }

  const totalLabel = drawer.querySelector('.cart__total-label');
  if (totalLabel && totalLabel.textContent.trim() !== 'Estimated total') {
    totalLabel.textContent = 'Estimated total';
  }

  const checkout = drawer.querySelector('.cart__checkout-button');
  if (checkout && checkout.textContent.trim() !== 'Checkout') checkout.textContent = 'Checkout';

  drawer.querySelectorAll('.cart-items__table-row').forEach((row) => {
    row.classList.add('gooka-cart-item');
  });
  drawer.querySelectorAll('.gooka-cart-vendor').forEach((vendor) => vendor.remove());

  if (drawer.dataset.gookaCartLoading === 'true') return;
  drawer.dataset.gookaCartLoading = 'true';

  void fetch('/cart.js', { credentials: 'same-origin' })
    .then((response) => {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    })
    .then((cart) => {
      if (!drawer.isConnected) return;

      const currency = cart.currency || window.Shopify?.currency?.active || 'USD';
      const threshold = 6000;
      const subtotal = Number(cart.total_price || 0);
      const remaining = Math.max(threshold - subtotal, 0);

      const subtotalNode = drawer.querySelector('[data-gooka-cart-subtotal]');
      const shippingNode = drawer.querySelector('[data-gooka-cart-shipping]');
      const messageNode = drawer.querySelector('[data-gooka-free-shipping-message]');
      const progress = drawer.querySelector('.gooka-free-shipping__track span');
      const money = formatCartMoney(subtotal, currency);

      if (subtotalNode) subtotalNode.textContent = money;
      if (shippingNode) shippingNode.textContent = remaining === 0 ? 'Free (US)' : 'Calculated at checkout';
      if (messageNode) {
        messageNode.textContent = remaining === 0
          ? 'Free US shipping unlocked'
          : `Add ${formatCartMoney(remaining, currency)} more for free US shipping`;
      }
      if (progress) progress.style.width = `${Math.min((subtotal / threshold) * 100, 100)}%`;
    })
    .catch(() => {})
    .finally(() => {
      if (drawer.isConnected) delete drawer.dataset.gookaCartLoading;
    });
};

const mountCartPage = () => {
  const page = document.querySelector('.cart-page');
  if (!page) return;

  page.classList.add('gooka-cart-page');

  const title = page.querySelector('.cart-title h1');
  if (title) {
    const bubble = title.querySelector('.cart-bubble');
    const label = page.classList.contains('cart-page--empty') ? 'Your cart is empty' : 'Your cart';
    const currentLabel = [...title.childNodes]
      .filter((node) => node !== bubble)
      .map((node) => node.textContent)
      .join('')
      .trim();
    if (currentLabel !== label) {
      [...title.childNodes].forEach((node) => {
        if (node !== bubble) node.remove();
      });
      title.prepend(document.createTextNode(label));
    }
  }

  if (page.classList.contains('cart-page--empty')) return;

  const discount = page.querySelector('.cart-discount');
  const discountTrigger = discount?.querySelector('.disclosure-trigger');
  const discountLabel = discountTrigger?.querySelector('.disclosure-trigger__label');
  const discountContent = discount?.querySelector('.disclosure-content');
  if (discount) discount.classList.add('gooka-cart-discount');
  if (discountLabel && discountLabel.textContent.trim() !== 'Discount code') {
    discountLabel.textContent = 'Discount code';
  }
  if (discountTrigger) discountTrigger.setAttribute('aria-expanded', 'true');
  if (discountContent) {
    discountContent.removeAttribute('inert');
    discountContent.removeAttribute('hidden');
  }

  const actions = page.querySelector('.cart-actions');
  if (actions && !page.querySelector('.gooka-gift-card')) {
    const giftCard = document.createElement('div');
    giftCard.className = 'gooka-gift-card';
    giftCard.innerHTML = `
      <label for="gooka-cart-page-gift-card-code">Gift card</label>
      <div class="gooka-gift-card__form">
        <input id="gooka-cart-page-gift-card-code" type="text" autocomplete="off" placeholder="Enter gift card code">
        <button type="button">Apply</button>
      </div>
      <p class="gooka-gift-card__note" aria-live="polite"></p>
    `;
    actions.insertAdjacentElement('afterend', giftCard);

    giftCard.querySelector('button')?.addEventListener('click', () => {
      const input = giftCard.querySelector('input');
      const note = giftCard.querySelector('.gooka-gift-card__note');
      if (!input?.value.trim()) {
        if (note) note.textContent = 'Enter a gift card code';
        input?.focus();
        return;
      }
      if (note) note.textContent = 'Gift cards are applied securely at checkout';
    });
  }

  const totalContainer = page.querySelector('.cart__total-container');
  if (totalContainer && !page.querySelector('.gooka-cart-estimates')) {
    const estimates = document.createElement('div');
    estimates.className = 'gooka-cart-estimates';
    estimates.innerHTML = `
      <div><span>Subtotal</span><span data-gooka-cart-subtotal></span></div>
      <div><span>Est. shipping</span><span data-gooka-cart-shipping></span></div>
      <div><span>Est. tax</span><span>Calculated at checkout</span></div>
    `;
    totalContainer.insertAdjacentElement('beforebegin', estimates);

    const freeShipping = document.createElement('div');
    freeShipping.className = 'gooka-free-shipping';
    freeShipping.innerHTML = `
      <div class="gooka-free-shipping__track" aria-hidden="true"><span></span></div>
      <p data-gooka-free-shipping-message></p>
    `;
    totalContainer.insertAdjacentElement('afterend', freeShipping);
  }

  const totalLabel = page.querySelector('.cart__total-label');
  if (totalLabel && totalLabel.textContent.trim() !== 'Estimated total') {
    totalLabel.textContent = 'Estimated total';
  }

  const checkout = page.querySelector('.cart__checkout-button');
  if (checkout && checkout.textContent.trim() !== 'Checkout') checkout.textContent = 'Checkout';

  page.querySelectorAll('.cart-items__table-row').forEach((row) => {
    row.classList.add('gooka-cart-item');
  });
  page.querySelectorAll('.gooka-cart-vendor').forEach((vendor) => vendor.remove());

  if (page.dataset.gookaCartLoading === 'true') return;
  page.dataset.gookaCartLoading = 'true';

  void fetch('/cart.js', { credentials: 'same-origin' })
    .then((response) => {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    })
    .then((cart) => {
      if (!page.isConnected) return;

      const currency = cart.currency || window.Shopify?.currency?.active || 'USD';
      const threshold = 6000;
      const subtotal = Number(cart.total_price || 0);
      const remaining = Math.max(threshold - subtotal, 0);
      const money = formatCartMoney(subtotal, currency);

      const subtotalNode = page.querySelector('[data-gooka-cart-subtotal]');
      const shippingNode = page.querySelector('[data-gooka-cart-shipping]');
      const messageNode = page.querySelector('[data-gooka-free-shipping-message]');
      const progress = page.querySelector('.gooka-free-shipping__track span');

      if (subtotalNode) subtotalNode.textContent = money;
      if (shippingNode) shippingNode.textContent = remaining === 0 ? 'Free (US)' : 'Calculated at checkout';
      if (messageNode) {
        messageNode.textContent = remaining === 0
          ? 'Free US shipping unlocked'
          : `Add ${formatCartMoney(remaining, currency)} more for free US shipping`;
      }
      if (progress) progress.style.width = `${Math.min((subtotal / threshold) * 100, 100)}%`;
    })
    .catch(() => {})
    .finally(() => {
      if (page.isConnected) delete page.dataset.gookaCartLoading;
    });
};

const mountProductPage = () => {
  const page = document.querySelector('.product-information');
  if (!page) return;

  page.classList.add('gooka-product-page');
  page.closest('main')?.setAttribute('data-product-transition', 'false');

  const grid = page.querySelector('.product-information__grid');

  if (!page.querySelector('.gooka-product-back')) {
    const back = document.createElement('button');
    back.className = 'gooka-product-back';
    back.type = 'button';
    back.setAttribute('aria-label', 'Back to products');
    back.textContent = '\u2190 Back';
    back.addEventListener('click', () => {
      const returnState = readCatalogReturnState();
      const isMatchingProduct = returnState?.productPath === window.location.pathname;

      if (returnState && isMatchingProduct) {
        back.disabled = true;
        document.documentElement.classList.add('gooka-catalog-is-restoring');
        if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
        window.location.replace(returnState.returnUrl);
        return;
      }

      if (window.history.length > 1) window.history.back();
      else window.location.assign('/collections/all');
    });
    (grid || page).prepend(back);
  }

  const back = page.querySelector('.gooka-product-back');
  if (grid && back && back.parentElement !== grid) grid.prepend(back);
};

function clearPersistedProductCardFocus() {
  const focused = document.activeElement;
  if (!(focused instanceof HTMLElement)) return;
  if (!focused.closest(':is(main[data-template^="collection"], main[data-template="search"]) .product-grid__card')) return;
  focused.blur();
}

const catalogReturnStorageKey = 'gooka-catalog-return';

function removeCatalogReturnState() {
  try {
    window.sessionStorage.removeItem(catalogReturnStorageKey);
  } catch {
    // Session storage can be unavailable in embedded browsers.
  }

  try {
    window.localStorage.removeItem(catalogReturnStorageKey);
  } catch {
    // Local storage can be unavailable in private browsing contexts.
  }
}

function readCatalogReturnState() {
  let value = null;

  try {
    value = window.sessionStorage.getItem(catalogReturnStorageKey);
  } catch {
    // Fall back to local storage in embedded browsers.
  }

  if (!value) {
    try {
      value = window.localStorage.getItem(catalogReturnStorageKey);
    } catch {
      return null;
    }
  }

  if (!value) return null;

  try {
    const state = JSON.parse(value);
    if (!state?.returnUrl || !state?.productPath || Date.now() - Number(state.savedAt || 0) > 60 * 60 * 1000) {
      removeCatalogReturnState();
      return null;
    }
    return state;
  } catch {
    return null;
  }
}

function saveCatalogReturnState(card, link) {
  const productUrl = new URL(link.href, window.location.origin);
  const returnUrl = new URL(window.location.href);
  const item = card.closest('.product-grid__item, li[data-page]');
  const productCardAnchor = link.id || card.querySelector('a[id][href*="/products/"]')?.id;

  if (item?.dataset.page) returnUrl.searchParams.set('page', item.dataset.page);
  if (productCardAnchor) returnUrl.hash = productCardAnchor;

  const state = {
    returnUrl: returnUrl.toString(),
    productPath: productUrl.pathname,
    viewportTop: card.getBoundingClientRect().top,
    scrollY: window.scrollY,
    savedAt: Date.now(),
  };

  let stateSaved = false;

  try {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.sessionStorage.setItem(catalogReturnStorageKey, JSON.stringify(state));
    stateSaved = true;
  } catch {
    // Embedded browsers can block session storage while allowing local storage.
  }

  try {
    window.localStorage.setItem(catalogReturnStorageKey, JSON.stringify(state));
    stateSaved = true;
  } catch {
    // The URL still provides a useful page and product anchor fallback.
  }

  if (stateSaved) window.history.replaceState(window.history.state, '', returnUrl.toString());
}

function disableProductCardTransitions() {
  const main = document.querySelector(':is(main[data-template^="collection"], main[data-template="search"])');
  main?.setAttribute('data-product-transition', 'false');

  document
    .querySelectorAll(':is(main[data-template^="collection"], main[data-template="search"]) product-card-link')
    .forEach((link) => link.setAttribute('data-product-transition', 'false'));
}

function restoreCatalogReturnPosition() {
  const main = document.querySelector(':is(main[data-template^="collection"], main[data-template="search"])');
  const state = readCatalogReturnState();
  if (!main || !state) return;

  const returnUrl = new URL(state.returnUrl);
  if (returnUrl.pathname !== window.location.pathname) return;

  if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
  document.documentElement.classList.add('gooka-catalog-is-restoring');

  const productLink = [...main.querySelectorAll('.product-grid__card a[href*="/products/"]')].find((link) => {
    try {
      return new URL(link.href, window.location.origin).pathname === state.productPath;
    } catch {
      return false;
    }
  });
  const card = productLink?.closest('.product-grid__card');
  if (!(card instanceof HTMLElement) || document.documentElement.dataset.gookaCatalogRestorePending === 'true') return;

  document.documentElement.dataset.gookaCatalogRestorePending = 'true';

  const placeCardAtSavedPosition = () => {
    if (!card.isConnected) return;

    const savedViewportTop = Number(state.viewportTop);
    const targetScroll = Number.isFinite(savedViewportTop)
      ? window.scrollY + card.getBoundingClientRect().top - savedViewportTop
      : Number(state.scrollY || 0);

    window.scrollTo(0, Math.max(0, targetScroll));
  };

  const finishRestore = () => {
    if (!card.isConnected) {
      delete document.documentElement.dataset.gookaCatalogRestorePending;
      return;
    }

    placeCardAtSavedPosition();

    const cleanUrl = new URL(window.location.href);
    cleanUrl.hash = '';
    window.history.replaceState(window.history.state, '', cleanUrl.toString());

    removeCatalogReturnState();

    try {
      window.sessionStorage.removeItem('custom-transition-type');
    } catch {
      // Storage can be unavailable in private browsing contexts.
    }

    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
    delete document.documentElement.dataset.gookaCatalogRestorePending;
    window.setTimeout(() => document.documentElement.classList.remove('gooka-catalog-is-restoring'), 240);
  };

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      if (!card.isConnected) {
        delete document.documentElement.dataset.gookaCatalogRestorePending;
        return;
      }

      clearPersistedProductCardFocus();
      card.querySelectorAll('[data-view-transition-triggered], [data-view-transition-type]').forEach((element) => {
        element.removeAttribute('data-view-transition-triggered');
        element.removeAttribute('data-view-transition-type');
      });

      placeCardAtSavedPosition();
      window.setTimeout(placeCardAtSavedPosition, 90);
      window.setTimeout(placeCardAtSavedPosition, 260);
      window.setTimeout(finishRestore, 560);
    });
  });
}

function handleCatalogReturn() {
  clearPersistedProductCardFocus();
  disableProductCardTransitions();
  restoreCatalogReturnPosition();
}

window.addEventListener('pagehide', clearPersistedProductCardFocus);
window.addEventListener('pageshow', handleCatalogReturn);
window.addEventListener('load', handleCatalogReturn);
window.addEventListener('popstate', () => window.setTimeout(handleCatalogReturn, 0));
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') handleCatalogReturn();
});

document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;
    if (
      event instanceof MouseEvent &&
      (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1)
    ) return;
    const card = event.target.closest(':is(main[data-template^="collection"], main[data-template="search"]) .product-grid__card');
    const interactiveElement = event.target.closest('button, input, label, select, [tabindex="1"]');
    if (!(card instanceof HTMLElement) || interactiveElement) return;

    const cardLink = card.querySelector('a.product-card__link[href*="/products/"], a[href*="/products/"]');
    if (!(cardLink instanceof HTMLAnchorElement)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    saveCatalogReturnState(card, cardLink);
    card.closest('product-card-link')?.setAttribute('data-product-transition', 'false');
    card.querySelectorAll('[data-view-transition-triggered], [data-view-transition-type]').forEach((element) => {
      element.removeAttribute('data-view-transition-triggered');
      element.removeAttribute('data-view-transition-type');
    });

    cardLink.blur();
    window.location.assign(cardLink.href);
  },
  true
);

mountProductCardActions();
mountTrueSoldOutResults();
mountCatalogToolbarCount();
mountCatalogFilterSheet();
mountHomepageFilterSheets();
mountCartDrawer();
mountCartPage();
mountProductPage();

const mountShopLoginButtons = () => {
  document
    .querySelectorAll('.account-actions__shop-login shop-login-button')
    .forEach((shopLoginButton) => {
      const shadowRoot = shopLoginButton.shadowRoot;
      if (!shadowRoot || shadowRoot.querySelector('[data-gooka-shop-login-style]')) return;

      const style = document.createElement('style');
      style.setAttribute('data-gooka-shop-login-style', '');
      style.textContent = `
        button,
        button > span {
          min-height: 36px !important;
          font-size: 10.5px !important;
          line-height: 1 !important;
          text-transform: uppercase !important;
        }

        button {
          border-radius: 0 !important;
        }

        button > span {
          gap: 4px !important;
          padding: 0 12px !important;
        }

        button svg {
          height: 10.5px !important;
        }

        @media (max-width: 749px) {
          button,
          button > span {
            font-size: 10.5px !important;
          }

          button svg {
            height: 10.5px !important;
          }
        }
      `;
      shadowRoot.append(style);
    });
};

mountShopLoginButtons();

const observer = new MutationObserver(() => {
  releaseStaleDialogScrollLock();
  mountArtistStrip();
  mountProductCardActions();
  mountTrueSoldOutResults();
  mountCatalogToolbarCount();
  mountCatalogFilterSheet();
  mountHomepageFilterSheets();
  mountCartDrawer();
  mountCartPage();
  mountProductPage();
  mountShopLoginButtons();
});
observer.observe(document.querySelector('#header-group') || document.body, {
  childList: true,
  subtree: true,
});

const mainContent = document.querySelector('#MainContent');
if (mainContent) {
  const mainObserver = new MutationObserver(() => {
    mountCartPage();
    mountProductPage();
  });
  mainObserver.observe(mainContent, { childList: true, subtree: true });
}

const catalogObserver = new MutationObserver(() => {
  releaseStaleDialogScrollLock();
  mountProductCardActions();
  mountTrueSoldOutResults();
  mountCatalogToolbarCount();
  mountCatalogFilterSheet();
  mountHomepageFilterSheets();
});
catalogObserver.observe(document.querySelector('main') || document.body, {
  childList: true,
  subtree: true,
});
